import React, { createContext, useContext, useState } from 'react';
import { LinkEditSlideIn, LinkList, LinksHeader } from '../components';
import LinkDeleteModal from '@components/dashboard/links/verwaltung/LinkDeleteModal';
import { redirect, useLoaderData } from 'react-router-dom';
import customFetch from '../utils/customFetch';
import LinkNavigation from '@components/dashboard/links/verwaltung/LinkNavigation';
import { useQuery } from '@tanstack/react-query';
import { LINK_TYPE } from '@utils/constants';

const linksQuery = {
  queryKey: ['links'],
  queryFn: async () => {
    const links = await customFetch.get(`/links`);
    return links;
  },
};

export const loader = (queryClient) => async () => {
  const links = await queryClient.ensureQueryData(linksQuery);
  return links;
};

export const LinksContext = createContext();

const Links = () => {
  const { data } = useQuery(linksQuery);
  const links = data;

  const [linkEdit, setLinkEdit] = useState({
    title: 'test',
    link: 'test',
    type: LINK_TYPE.LINK,
  });
  const [showSlideIn, setShowSlideIn] = useState(false);
  const [editIconValue, setEditIconValue] = useState(linkEdit.icon);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [listItems, setListItems] = useState(links.data.links);

  return (
    <>
      <LinksContext.Provider
        value={{
          links,
          linkEdit,
          showSlideIn,
          setShowSlideIn,
          setLinkEdit,
          editIconValue,
          setEditIconValue,
          openDeleteModal,
          setOpenDeleteModal,
          listItems,
          setListItems,
        }}
      >
        <LinkEditSlideIn />
        <LinkDeleteModal />
        <LinkNavigation />
        <LinksHeader />
        <LinkList />
      </LinksContext.Provider>
    </>
  );
};

export const useLinksContext = () => useContext(LinksContext);
export default Links;
